// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonPrimaryToggle = 2;
var ButtonPrimaryToggleOff = 2;
var ButtonSecondaryToggle = 2;
var ButtonSecondaryToggleOff = 2;
var ButtonTertiaryToggle = 2;
var ButtonTertiaryToggleOff = 2;
var ButtonPrimaryToggleGroupOn = 1;
var ButtonPrimaryToggleGroupOff = 1;
var ButtonSecondaryToggleGroupOn = 1;
var ButtonSecondaryToggleGroupOff = 1;
var ButtonTertiaryToggleGroupOn = 1;
var ButtonTertiaryToggleGroupOff = 1;
var FieldsDefault = 1;
var FieldsError = 2;
var FieldsFocus = 2;
var PaginationNumbered = 1;
var PaginationNumberedUnselected = 1;
var Toggle = 2;
var BorderWidthSemanticsAll = {
  ButtonPrimaryToggle: ButtonPrimaryToggle,
  ButtonPrimaryToggleGroupOff: ButtonPrimaryToggleGroupOff,
  ButtonPrimaryToggleGroupOn: ButtonPrimaryToggleGroupOn,
  ButtonPrimaryToggleOff: ButtonPrimaryToggleOff,
  ButtonSecondaryToggle: ButtonSecondaryToggle,
  ButtonSecondaryToggleGroupOff: ButtonSecondaryToggleGroupOff,
  ButtonSecondaryToggleGroupOn: ButtonSecondaryToggleGroupOn,
  ButtonSecondaryToggleOff: ButtonSecondaryToggleOff,
  ButtonTertiaryToggle: ButtonTertiaryToggle,
  ButtonTertiaryToggleGroupOff: ButtonTertiaryToggleGroupOff,
  ButtonTertiaryToggleGroupOn: ButtonTertiaryToggleGroupOn,
  ButtonTertiaryToggleOff: ButtonTertiaryToggleOff,
  FieldsDefault: FieldsDefault,
  FieldsError: FieldsError,
  FieldsFocus: FieldsFocus,
  PaginationNumbered: PaginationNumbered,
  PaginationNumberedUnselected: PaginationNumberedUnselected,
  Toggle: Toggle
};

export { BorderWidthSemanticsAll, ButtonPrimaryToggle, ButtonPrimaryToggleGroupOff, ButtonPrimaryToggleGroupOn, ButtonPrimaryToggleOff, ButtonSecondaryToggle, ButtonSecondaryToggleGroupOff, ButtonSecondaryToggleGroupOn, ButtonSecondaryToggleOff, ButtonTertiaryToggle, ButtonTertiaryToggleGroupOff, ButtonTertiaryToggleGroupOn, ButtonTertiaryToggleOff, FieldsDefault, FieldsError, FieldsFocus, PaginationNumbered, PaginationNumberedUnselected, Toggle, BorderWidthSemanticsAll as default };
